// extracted by mini-css-extract-plugin
module.exports = {"Category":"Category_Category__2hUIc","NotPurchased":"Category_NotPurchased__2yjcr","Active":"Category_Active__2zvZk","scifi":"Category_scifi__1syCL"};